import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-response-result',
  standalone: true,
  imports: [CommonModule, ButtonModule, DynamicDialogModule],
  templateUrl: './response-result.component.html',
})
export class ResponseResultComponent implements OnInit {
  ref: DynamicDialogRef | undefined;

  message: string = this.config.data.message;

  icon: string = this.config.data.status === 'success' ? 'pi-check' : 'pi-times';

  status: string = this.config.data.status;

  bgColor: string = this.config.data.status === 'success' ? 'bg-green-200' : 'bg-red-200';

  iconColor: string = this.config.data.status === 'success' ? 'text-green-700' : 'text-red-700';

  constructor(
    public dialogService: DialogService,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {}
  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }
}
